var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section-holder mycourse-cards"
  }, [_c('div', {
    staticClass: "pb-3 row justify-content-end"
  }, [_c('h6', {
    staticClass: "col-md-12 main-title"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.Courses')))])]), _vm._v(" "), (_vm.$store.getters.getItemsEnrolledByType('CO') != undefined && _vm.$store.getters.getItemsEnrolledByType('CO') != null && _vm.$store.getters.getItemsEnrolledByType('CO').length != 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.$store.getters.getItemsEnrolledByType('CO')), function(course, index) {
    return _c('div', {
      key: index,
      staticClass: "col-sm-6 col-md-5 col-lg-4 col-xl-3"
    }, [_c('div', {
      staticClass: "card-design"
    }, [(course.thumbnail.length !== 0) ? _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": _vm.makePath(course.thumbnail),
        "alt": ""
      }
    })]) : _c('div', {
      staticClass: "card-design__img"
    }, [_c('img', {
      attrs: {
        "src": require("../../../static/assets/images/defaultCO.jpg"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-design__data"
    }, [(_vm.instanceName !== 'MAHADEMY') ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading text-truncate",
      attrs: {
        "tag": "h3",
        "title": course.title,
        "to": {
          name: 'coursePage',
          params: {
            contentId: course.contentId
          }
        }
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName === 'MAHADEMY') ? _c('h3', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "card-design__data-heading no-line text-truncate",
      attrs: {
        "title": course.title
      }
    }, [_vm._v(_vm._s(course.title))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('p', {
      staticClass: "card-design__data-cost"
    }, [_vm._v(_vm._s(course.price) + " " + _vm._s(course.price > 1 ? 'Points' : 'Point'))]) : _vm._e(), _vm._v(" "), (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "ratingText"
    }, [_vm._v(_vm._s(_vm.$t('course.my_rating')))]) : _vm._e(), _vm._v(" "), (parseInt(course.rating) == 0 && _vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": parseInt(course.rating),
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : (_vm.instanceName !== 'MAHADEMY') ? _c('div', {
      staticClass: "card-design__data-ratings"
    }, [_c('star-rating', {
      attrs: {
        "rating": course.rating,
        "read-only": true,
        "increment": 0.5,
        "max-rating": 5,
        "inactive-color": "#96999a",
        "active-color": "#ffc000",
        "star-size": 15
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('share-on-media', {
      attrs: {
        "item": course,
        "labelOnTop": true
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row box-action"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn btn-green-o",
      on: {
        "click": function($event) {
          _vm.goToCourse(course)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.labels.GO_TO_COURSE')))])])])], 1)])])
  })) : _c('div', {
    staticClass: "noticemsg-alt"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('myCourses.labels.NoCourses')))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af21728","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myCourses/mycourseCards.vue
// module id = s3SC
// module chunks = 1